import React, { Component } from 'react';

// Modules
import ChampView from './ChampView';
import { getCompetitorsFromChamp, getTeams, getWeightChart } from '../../utils/competitorsFunctions';
import { getChamp } from '../../utils/champsFunctions';

export default class Champ extends Component {

    constructor(props) {
        super(props);
        this.state = {
            champ: null,
            champId: null,

            competitorsList: [],

            modalRegistration: false,
            quadroDePesos: [],
            arrayOfTeams: [],

            modalWeigthTable: false,
        }
    }

    componentDidMount = () => {
        window.scrollTo(0, 0);
        const params = new URLSearchParams(window.location.search);
        let id = params.get('id');
        this.getChamp(id);
        this.getTeamsLocal();
        this.getWeightChartLocal();
        this.getCompetitorsList(id);
    };


    getChamp = async (key) => {
        let champ = await getChamp(key);
        this.setState({
            champ: champ,
            champId: key,
        });
    }

    getTeamsLocal = async () => {
        let localArray = await getTeams();

        this.setState({
            arrayOfTeams: localArray,
        });
    }

    getWeightChartLocal = async () => {
        let quadroDePesos = await getWeightChart();
        this.setState({
            quadroDePesos: quadroDePesos,
        });
    }

    getCompetitorsList = async (key) => {
        let competitorsArray = await getCompetitorsFromChamp(key);
        this.setState({ competitorsList: competitorsArray });
    }

    /* Registration modal stuffs */
    openModalRegistration = () => {
        this.setState({ modalRegistration: true })
    }

    closeModalRegistration = () => {
        this.setState({ modalRegistration: false })
    }

    render() {
        return (
            <ChampView
                champ={this.state.champ}
                champId={this.state.champId}

                modalRegistration={this.state.modalRegistration}
                openModalRegistration={() => this.openModalRegistration()}
                closeModalRegistration={() => this.closeModalRegistration()}
                quadroDePesos={this.state.quadroDePesos}
                arrayOfTeams={this.state.arrayOfTeams}

                updateStudentList={() => this.getCompetitorsList(this.state.champId)}
                competitorsList={this.state.competitorsList}

                modalWeigthTable={this.state.modalWeigthTable}
                openModalWeigthTable={() => this.setState({ modalWeigthTable: true })}
                closeModalWeigthTable={() => this.setState({ modalWeigthTable: false })}
            />
        );
    }
}